import Swal from 'sweetalert2';

const swal = Swal.mixin({
  showConfirmButton: false,
  showCancelButton: false,
  timer: 1600,
  toast: false,
  position: 'center',
});

export default swal;